import React from "react";
import { useTranslation } from "react-i18next";
import { ButtonSkeleton } from "@features/skeletons/common/ButtonSkeleton/ButtonSkeleton";
import { Skeleton } from "@components/Skeleton/Skeleton";

export const BillsActionBarSkeleton: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex w-full justify-end gap-3 lg:justify-between">
      <div className="hidden sm:flex xl:hidden">
        <ButtonSkeleton
          className="w-full"
          title={t("billsPage.actions.add")}
          withIcon
        />
      </div>
      <div className="hidden gap-3 xl:flex">
        <ButtonSkeleton
          className="w-full"
          title={t("billsPage.actions.addProvider")}
          withIcon
        />
        <ButtonSkeleton
          className="w-full"
          title={t("billsPage.actions.addPayer")}
          withIcon
        />
        <ButtonSkeleton
          className="w-full"
          title={t("billsPage.actions.addHouse")}
          withIcon
        />
      </div>
      <div className="lg:ml-auto">
        <div className="hidden gap-3 sm:flex">
          <ButtonSkeleton className="w-[160px]" />
          <ButtonSkeleton className="w-[160px]" />
        </div>
        <div className="flex gap-3 sm:hidden">
          <Skeleton variant="circular" />
          <Skeleton variant="circular" />
        </div>
      </div>
    </div>
  );
};
